declare global {
  interface Window {
    hj: (functionName: string, tags: string[]) => void;
  }
}

export const tagRecording = (tag: string) => {
  if (typeof window !== 'undefined' && typeof window.hj === 'function') {
    window.hj('tagRecording', [tag]);
  }
};
